
    import '/Users/lijixiang/Work/power-design/site/docs/power-design/department-user-selector.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-department-user-selector-demo-department-user-selector","docs-power-design-department-user-selector-demo-user-list","docs-power-design-department-user-selector-demo-single"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/power-design/department-user-selector.md?type=demo')
};